const CONSENT_KEY = "longview.analytics-consent";
let initializing = null;

export const isAnalyticsConfigured = () => (
  (process.env.REACT_APP_ANALYTICS_PROVIDER || "").trim().toLowerCase() === "posthog"
  && Boolean((process.env.REACT_APP_POSTHOG_KEY || "").trim())
  && Boolean((process.env.REACT_APP_POSTHOG_HOST || "").trim())
);

export const getAnalyticsConsent = () => {
  try {
    return window.localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

export const setAnalyticsConsent = (choice) => {
  try {
    window.localStorage.setItem(CONSENT_KEY, choice);
  } catch {
    // The user's storage settings may prevent persistence. Analytics stays off.
  }
};

const assetHostFor = (apiHost) => (
  apiHost.includes(".i.posthog.com")
    ? apiHost.replace(".i.posthog.com", "-assets.i.posthog.com")
    : apiHost
);

export const initializeAnalytics = () => {
  if (!isAnalyticsConfigured() || getAnalyticsConsent() !== "accepted") return Promise.resolve(false);
  if (window.posthog?.__loaded) return Promise.resolve(true);
  if (initializing) return initializing;

  const key = process.env.REACT_APP_POSTHOG_KEY.trim();
  const apiHost = process.env.REACT_APP_POSTHOG_HOST.trim().replace(/\/$/, "");
  initializing = new Promise((resolve) => {
    const script = document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = `${assetHostFor(apiHost)}/static/array.js`;
    script.onload = () => {
      if (!window.posthog?.init) {
        resolve(false);
        return;
      }
      window.posthog.init(key, {
        api_host: apiHost,
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: false,
        disable_session_recording: true,
        person_profiles: "identified_only",
        persistence: "memory",
      });
      resolve(true);
    };
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });
  return initializing;
};

export const trackPageView = (pathname) => {
  if (!window.posthog?.capture || getAnalyticsConsent() !== "accepted") return;
  window.posthog.capture("$pageview", {
    $current_url: `${window.location.origin}${pathname}`,
    path: pathname,
  });
};
